// provided by Vitali from AT codebase
export enum TradeSetupOrderType {
    Stop = 1,
    Limit = 2,
    StopLimit = 3,
    Market = 4,
    Unknown = 5,
}

// provided by Vitali from AT codebase
export enum TradeSetupOrderDirection {
    Buy = 1,
    Sell = 3,
}
